if (!customElements.get('card-media-carousel')) {
  class CardMediaCarousel extends HTMLElement {
    connectedCallback() {
      if (this.swiper || typeof Swiper === 'undefined') return;

      this.swiper = new Swiper(this, {
        slidesPerView: 1,
        threshold: 5,
        navigation: {
          prevEl: this.querySelector(
            '.product-card__slider-button--prev'
          ),
          nextEl: this.querySelector(
            '.product-card__slider-button--next'
          )
        },
        scrollbar: {
          el: this.querySelector('.product-card__slider-scrollbar'),
          draggable: true
        }
      });
    }

    disconnectedCallback() {
      this.swiper?.destroy();
      this.swiper = null;
    }
  }

  customElements.define('card-media-carousel', CardMediaCarousel);
}
